// extracted by mini-css-extract-plugin
module.exports = {"container":"Container_container__A7FAx","article":"Container_article__NcxJh","guide":"Container_guide___Wf4L","small":"Container_small__0k_5W","wide":"Container_wide__DEeFc"};